import {Button} from 'antd';
import dayjs from 'dayjs';

import {Text} from '../../../../../component/text/text';
import {FormattedDateTime} from '../../../../../provider/locale/formatted-date-time';
import {useFutureMarketingEvent} from '../use-knowledge-videos';

import marketingEventImageSrc from './images/marketing-event-call.png';
import * as styles from './future-marketing-event.scss';

export function FutureMarketingEvent(): JSX.Element | null {
    const marketingEventData = useFutureMarketingEvent();

    if (!marketingEventData || dayjs().isAfter(new Date(marketingEventData.config.date))) {
        return null;
    }

    return (
        <div className={styles.FutureMarketingEvent}>
            <img
                alt="incomming-marketing-event"
                className={styles.FutureMarketingEvent_icon}
                src={marketingEventImageSrc}
            />

            <div className={styles.FutureMarketingEvent_content}>
                <Text block>
                    {marketingEventData.config.name} |{' '}
                    <FormattedDateTime
                        options={{
                            day: 'numeric',
                            month: 'long',
                        }}
                        value={new Date(marketingEventData.config.date)}
                    />
                </Text>

                <Button href={marketingEventData.documentationLink} size="small" target="_blank" type="primary">
                    {marketingEventData.config.buttonText}
                </Button>
            </div>
        </div>
    );
}
